/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosOrder } from '../../models/pos-order';

export interface PosOrdersControllerGetById$Params {
  id: string;
}

export function posOrdersControllerGetById(http: HttpClient, rootUrl: string, params: PosOrdersControllerGetById$Params, context?: HttpContext): Observable<StrictHttpResponse<PosOrder>> {
  const rb = new RequestBuilder(rootUrl, posOrdersControllerGetById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosOrder>;
    })
  );
}

posOrdersControllerGetById.PATH = '/pos/orders/{id}';
